import React from 'react';
import Box from "@mui/material/Box";
import {Grid} from "@mui/material";
import {LogoCard} from "./LogoCard";
import {
  editedLogoHasChangesSelector,
  hasAutomaticLogoSelector,
  ILogoInfos,
  logosSelector,
  reorderLogos
} from "./logosSlice";
import {FormattedMessage} from "react-intl";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch} from "../../app/store";
import { ReactSortable } from 'react-sortablejs'
import {saveLogoMove} from "../../app/logosAPI";

export const LogosList = (props: {
  // logos: ILogoInfos[],
  draggable: boolean
}) => {

  // const {logos, draggable} = props;
  const {draggable} = props;
  const logos = useSelector(logosSelector);
  const dispatch = useDispatch<AppDispatch>();

  const logoHasChanges = useSelector(editedLogoHasChangesSelector);
  const hasAutomaticLogo = useSelector(hasAutomaticLogoSelector);

  // automatic logo are not sortable
  if (hasAutomaticLogo)
    return(
      <Box sx={{width: '180px'}}>
        <Grid container spacing={1} className='logos'>
            { hasAutomaticLogo &&
                <div className='temporary'>
                  <FormattedMessage id="logos.temporary-logos" />
                </div>
            }

            {logos && logos.map(logo =>
              <LogoCard logo={logo} key={`logo-card-${logo.id}`} editable={logoHasChanges === false} draggable={draggable} />
            )}

        </Grid>
      </Box>
    )

  // no automatic logo, we can sort
  return (
    <Box sx={{ width: 180 }}>
      {/*<Grid container spacing={1} className='logos'>*/}
        <ReactSortable<ILogoInfos>
          list={logos.map((logo) => ({ ...logo }))}
          setList={() => {}}
          animation={400} delay={3}
          easing='cubic-bezier(0.65, 0, 0.35, 1)'
          dragoverBubble={false}
          // direction="horizontal"
          onEnd={({ oldIndex, newIndex }) => {
            console.log('Drag oldIndex', oldIndex, 'newIndex', newIndex)
            if (typeof oldIndex === 'number' && typeof newIndex === 'number' && oldIndex !== newIndex) {
              dispatch(reorderLogos({ fromIndex: oldIndex, toIndex: newIndex }))
              saveLogoMove(oldIndex, newIndex)
            }
          }}
          className="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-1 logos"
        >
          {logos.map(logo => (
            // <div key={logo.id} className="logo">
              <LogoCard key={logo.id} logo={logo} editable={logoHasChanges === false} draggable={draggable} />
            // </div>
          ))}
        </ReactSortable>
      {/*</Grid>*/}
    </Box>
  )
}
